// @flow

import property from 'lodash/fp/property';
import differenceBy from 'lodash/differenceBy';
import merge from '../../util/merge';
import * as schemas from '../../schemas';

type State = {};

type Action = {
  payload: {
    processID: string
  },
  response: Array<*>
};

export function getProcessFieldsSuccess(state: State, action: Action) {
  const processID = action.payload.processID;
  const fields = action.response;
  const processes = property('processes', state) || {};
  const process = property(`processes.${processID}`, state) || {};
  const nextState: Object = {
    ...state,
    processes: {
      ...processes,
      [processID]: {
        ...process,
        fields
      }
    }
  };
  const nextStateFields = differenceBy(
    Object.values(nextState.fields),
    fields,
    'fieldName'
  );
  const fieldIDAttribute = schemas.FIELD.getIdAttribute();
  nextState.fields = schemas.mapEntitiesByID(nextStateFields, fieldIDAttribute);
  return merge(nextState, {
    fields: schemas.mapEntitiesByID(fields, fieldIDAttribute)
  });
}



// WEBPACK FOOTER //
// ./js/reducers/entities/processFields.js